import { render, staticRenderFns } from "./cpMessage.vue?vue&type=template&id=0f09edce"
import script from "./cpMessage.vue?vue&type=script&lang=js"
export * from "./cpMessage.vue?vue&type=script&lang=js"
import style0 from "./cpMessage.vue?vue&type=style&index=0&id=0f09edce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports